/** Korean locale for system-settings-ui. */
import type { SystemSettingsLocale } from './en'

export const systemSettingsKo = {
  systemSettings: {
    title: `시스템 설정`,
    tabs: {
      general: `일반`,
      defaults: `기본값`,
      recording: `통화 녹음`,
    },
    common: {
      save: `변경 사항 저장`,
      active: `활성`,
      inactive: `비활성`,
      yes: `예`,
      no: `아니오`,
      loading: `로딩 중...`,
      selectOption: `-- 선택 --`,
      none: `없음`,
      unsavedChanges: `저장되지 않은 변경 사항`,
    },
    general: {
      title: `일반`,
      defaultTimeZone: `기본 시간대`,
      callParkTimeout: `통화 대기 시간(초)`,
      callParkTimeoutHelp:
        '통화가 파킹된 후 돌아오기까지의 시간(초). 최소 30초, 최대 1800초. 권장: 300.',
      callParkWarning: `발신자를 {{minutes}}분 동안 대기 상태로 두시겠습니까?`,
      extensionsTitle: `내선`,
      extensionDigits: `내선 번호 자릿수`,
      enableIntercom: `인터콤 사용`,
      searchTimezone: '시간대 검색...',
      noTimezonesFound: '시간대를 찾을 수 없습니다',
    },
    defaults: {
      voiceTitle: `음성`,
      defaultAreaCode: `기본 지역 코드`,
      areaCodeRange: `지역 코드는 200에서 998 사이여야 합니다`,
      areaCodeDisallowed: `이 지역 코드는 허용되지 않습니다`,
      defaultCallerId: `기본 발신자 ID`,
      faxTitle: `팩스`,
      defaultFaxNumber: `기본 팩스 번호`,
      defaultVirtualFax: `기본 가상 팩스`,
      defaultVirtualFaxSearchPlaceholder: `가상 팩스 내선 검색...`,
      defaultVirtualFaxSearchAriaLabel: `이름 또는 번호로 가상 팩스 내선 검색`,
      defaultVirtualFaxNoMatches: `해당 검색어와 일치하는 가상 팩스 내선이 없습니다.`,
      emergencyTitle: `긴급 기본값`,
      emergencyName: `긴급 이름`,
      emergencyNumber: `긴급 번호`,
      emergencyNumberHelp: `이 필드는 읽기 전용이며 여기서 변경할 수 없습니다.`,
      emergencyAlert: `긴급 알림`,
      holdMusicTitle: `대기 음악`,
      holdMusicPlaylist: `대기 음악`,
      noPlaylists: `사용 가능한 재생 목록이 없습니다`,
      playlistNotPlayableSuffix: `(오디오 트랙 없음)`,
      playlistEmptyError: `선택한 대기 음악 재생 목록에 오디오 트랙이 없습니다. 트랙을 추가하거나 다른 재생 목록을 선택하세요.`,
    },
    recording: {
      title: `통화 녹음`,
      enableInbound: `수신 통화 녹음 사용`,
      enableOutbound: `발신 통화 녹음 사용`,
      enableInternal: `내선 통화 녹음 사용`,
    },
    toast: {
      saveSuccess: `설정이 성공적으로 저장되었습니다`,
      saveError: `설정 저장에 실패했습니다`,
      validationError: `저장할 수 없습니다 — 위의 오류를 수정해 주세요`,
    },
    error: {
      loadFailed: `시스템 설정을 불러오지 못했습니다. 다시 시도해 주세요.`,
    },
  },
} satisfies SystemSettingsLocale
